var handlebars_runtime = {exports: {}};

export { handlebars_runtime as h };
